// Generated from D:/PJ/ieum/ieum-auto/apps/realtorauto-web/components/realtorauto/RealtorAutoDeferredPanel.tsx
// Source SHA-256: f724b4658e2cee971693d023c5dda12e98ceec8a778c8d600134d872aa139060
// 원본 RealtorAuto 편집기 동기화 파일입니다. 직접 수정하지 말고 syncRealtorAutoOriginalTemplateEditor.cjs를 실행하세요.
'use client';

import { Loader2 } from 'lucide-react';
import { memo, useEffect, useState } from 'react';
export const RealtorAutoDeferredPanel = memo(function RealtorAutoDeferredPanel({
  active,
  children,
  delayMs = 0,
  label = '편집 영역을 준비하는 중입니다.',
  minHeightClassName = 'min-h-[360px]'
}) {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    if (!active) {
      setReady(false);
      return undefined;
    }
    let frameId = 0;
    let timerId;
    frameId = window.requestAnimationFrame(() => {
      timerId = window.setTimeout(() => setReady(true), delayMs);
    });
    return () => {
      window.cancelAnimationFrame(frameId);
      if (timerId !== undefined) window.clearTimeout(timerId);
    };
  }, [active, delayMs]);
  if (!active) return null;
  if (ready) return <>{children}</>;
  return <div className={`flex ${minHeightClassName} items-center justify-center rounded-lg border border-dashed border-slate-200 bg-white text-sm font-semibold text-slate-500`} data-realtorauto-deferred-panel>
      <Loader2 className="mr-2 h-4 w-4 animate-spin text-blue-600" aria-hidden />
      {label}
    </div>;
});
